import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { Lock } from "lucide-react";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { PasswordInput } from "@/components/ui/password-input";

export const AdminLockSettingsCard = () => {
  const [configured, setConfigured] = useState(null);
  const [f, setF] = useState({ current: "", password: "", confirm: "", hint: "" });
  const [saving, setSaving] = useState(false);
  const load = () => api.get("/admin-lock/status").then((r) => setConfigured(r.data.configured)).catch(() => {});
  useEffect(() => { load(); }, []);
  const set = (k) => (e) => setF((p) => ({ ...p, [k]: e.target.value }));

  const save = async (e) => {
    e.preventDefault();
    if (f.password.length < 4) return toast.error("A senha precisa ter pelo menos 4 caracteres");
    if (f.password !== f.confirm) return toast.error("As senhas não conferem");
    setSaving(true);
    try {
      await api.post("/admin-lock/config", { password: f.password, hint: f.hint, current_password: f.current || null });
      toast.success(configured ? "Senha do bloqueio alterada" : "Senha do bloqueio cadastrada");
      setF({ current: "", password: "", confirm: "", hint: "" });
      load();
    } catch (err) { toast.error(err?.response?.data?.detail || "Falha ao salvar"); } finally { setSaving(false); }
  };

  return (
    <section className="bg-white rounded-2xl border border-slate-100 card-shadow p-5" data-testid="admin-lock-settings">
      <h3 className="font-heading text-base font-bold text-slate-900 flex items-center gap-2"><Lock className="w-4 h-4 text-[#1e3a8a]" />Bloqueio da área Adm</h3>
      <p className="text-xs text-slate-500 mt-1 mb-4">
        {configured ? "Senha cadastrada. Para trocar, informe a atual." : "Cadastre a senha usada para desbloquear a área Adm em todos os aparelhos."}
      </p>
      <form onSubmit={save} className="grid sm:grid-cols-2 gap-3" autoComplete="off">
        {configured && <PasswordInput autoComplete="off" placeholder="Senha atual do bloqueio" value={f.current} onChange={set("current")} className="sm:col-span-2" data-testid="lock-cfg-current" />}
        <PasswordInput autoComplete="new-password" placeholder="Nova senha do bloqueio" value={f.password} onChange={set("password")} data-testid="lock-cfg-password" />
        <PasswordInput autoComplete="new-password" placeholder="Repita a senha" value={f.confirm} onChange={set("confirm")} data-testid="lock-cfg-confirm" />
        <Input placeholder="Lembrete da senha (dica)" value={f.hint} onChange={set("hint")} maxLength={200} className="sm:col-span-2" data-testid="lock-cfg-hint" />
        <Button type="submit" disabled={saving || !f.password} className="sm:col-span-2 bg-[#1e3a8a] hover:bg-[#1e40af] text-white" data-testid="lock-cfg-save">
          {saving ? "Salvando…" : configured ? "Trocar senha" : "Cadastrar senha"}
        </Button>
      </form>
    </section>
  );
};
